import AuthService from '@/services/auth.service'

const state = {
  user: AuthService.getCurrentUser(),
  token: AuthService.getToken(),
  isAuthenticated: AuthService.isAuthenticated(),
  loading: false,
  error: null,
}

const getters = {
  user: (state) => state.user,
  token: (state) => state.token,
  isAuthenticated: (state) => state.isAuthenticated,
  loading: (state) => state.loading,
  error: (state) => state.error,
  userPermissions: (state) => state.user?.permissions || [],
  userRoles: (state) => state.user?.roles || [],
}

const mutations = {
  SET_USER(state, user) {
    state.user = user
  },
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_AUTHENTICATED(state, value) {
    state.isAuthenticated = value
  },
  SET_LOADING(state, value) {
    state.loading = value
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  CLEAR_AUTH(state) {
    state.user = null
    state.token = null
    state.isAuthenticated = false
    state.error = null
  },
}

const actions = {
  async login({ commit }, credentials) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    
    try {
      const response = await AuthService.login(credentials)
      
      if (response.success) {
        const { token, user } = response.data
        
        AuthService.setAuthData(token, user)
        
        commit('SET_USER', user)
        commit('SET_TOKEN', token)
        commit('SET_AUTHENTICATED', true)
        
        return { success: true, message: response.message }
      } else {
        commit('SET_ERROR', response.message || 'فشل تسجيل الدخول')
        return { success: false, message: response.message }
      }
    } catch (error) {
      const message = error.response?.data?.message || 'حدث خطأ أثناء تسجيل الدخول'
      commit('SET_ERROR', message)
      return { success: false, message }
    } finally {
      commit('SET_LOADING', false)
    }
  },

  logout({ commit }) {
    AuthService.logout()
    commit('CLEAR_AUTH')
  },

  checkAuth({ commit }) {
    const token = AuthService.getToken()
    const user = AuthService.getCurrentUser()
    
    if (token && user) {
      commit('SET_USER', user)
      commit('SET_TOKEN', token)
      commit('SET_AUTHENTICATED', true)
    } else {
      commit('CLEAR_AUTH')
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
